import React, { Component } from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {Pagination} from "react-bootstrap";

class PaginationBar extends Component {
    pagesToShow() {
        let slidePerDirection = (this.props.show  - 1) / 2;
        let pageNumbers = [];

        for(let i = 0; i <= slidePerDirection; i++) {
            pageNumbers.push(this.props.current + i)
        }

        for(let i = 0; i <= slidePerDirection; i++) {
            pageNumbers.push(this.props.current - i)
        }

        // filter out the bullshit
        pageNumbers = Array.from(new Set(pageNumbers)).filter(function(nr) {
            return nr >= 0 && nr <= this.props.last;
        }.bind(this));

        if(pageNumbers.length !== this.props.show) {
            // TODO: compliment the missing page numbers (we must have this.props.show in total)
        }

        return pageNumbers.sort(function(a,b) {
            return a - b;
        });
    }

    render() {
        return (
            <div className="kate-pagination-bar">
                <Pagination>
                    {this.props.current !== this.props.first ?
                        <Pagination.First onClick={e => this.props.onChange(this.props.first)}  />
                        : <Pagination.First disabled /> }

                    {this.props.current >= this.props.first + 1 ?
                        <Pagination.Prev onClick={e => this.props.onChange(this.props.current - 1)}/>
                        :  <Pagination.Prev disabled /> }


                    {this.pagesToShow().map(nr =>
                            <Pagination.Item key={nr} onClick={e => this.props.onChange(nr)}
                                             active={nr === this.props.current}>{nr+1}</Pagination.Item>
                    )}

                    {this.props.current < this.props.last ?
                        <Pagination.Next onClick={e => this.props.onChange(this.props.current+1)}/>
                        : <Pagination.Next disabled /> }

                    { this.props.current !== this.props.last ?
                        <Pagination.Last onClick={e => this.props.onChange(this.props.last)}/>
                        :  <Pagination.Last disabled /> }

                </Pagination>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return { pendingCalls: state.pendingCalls, customer: state.currentCustomer,
        propertyDefinitions: state.propertyDefinitions};
};

export default withRouter(connect(mapStateToProps)(PaginationBar));



// WEBPACK FOOTER //
// ./src/components/reusables/PaginationBar.js